/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import Error401 from './views/Error401';
import Error404 from './views/Error404';
import Error500 from './views/Error500';
import LoggedOut from './views/LoggedOut/LoggedOut';
import Group from './views/Group';
import Repository from './views/Repository';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/groups" />
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: Error401
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: Error500
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/auth',
    component: ErrorLayout,
    routes: [
      {
        path: '/auth/logged-out',
        exact: true,
        component: LoggedOut
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/groups/:id?',
        exact: true,
        component: Group
      },
      {
        path: '/repositories/:id?',
        exact: true,
        component: Repository
      },
      {
        path: '/public-repositories/:id?',
        exact: true,
        component: lazy(() => import('views/PublicRepository'))
      },
      {
        path: '/inclusive-access/:id?',
        exact: true,        
        component: lazy(() => import('views/InclusiveAccess'))
      },
      {
        path: '/users',
        exact: true,
        component: lazy(() => import('views/Users/Users'))
      },
      {
        path: '/users/:id',
        exact: true,
        component: lazy(() => import('views/Profile/Profile'))
      },
      {
        path: '/users/:id/login-history',
        exact: true,
        component: lazy(() => import('views/LoginHistory/LoginHistory'))
      },
      {
        path: '/approvals',
        exact: true,
        component: lazy(() => import('views/FacultyApprovals/FacultyApprovals'))
      },
      {
        path: '/access-codes',
        exact: true,
        component: lazy(() => import('views/AccessCodes/AccessCodes'))
      },
      {
        path: '/register',
        exact: true,
        component: lazy(() => import('views/Register/Register'))
      },
      {
        path: '/mail',
        exact: true,
        component: lazy(() => import('views/Mail/Mail'))
      },
      {
        path: '/mail-queue',
        exact: true,
        component: lazy(() => import('views/MailQueue/MailQueue'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];


const adminRoutes = new Set(['/public-repositories', '/inclusive-access', '/users', '/approvals', '/access-codes', '/register', '/mail', '/mail-queue'])
export const isAdminRoute = (pathname => adminRoutes.has(pathname))

export default routes;
